import { React, useState} from 'react';
import {
    Box,
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    Button,
    useDisclosure,
    ModalCloseButton,
    Flex,
    Icon,
    Textarea,} from '@chakra-ui/react';

import SimpleSidebar from "views/global/SimpleSidebar";
import BoxDataTable from "views/global/BoxDataTable";
import SidebarScroll from 'components/scroll/SidebarScroll';
import { QuickAlert } from "theme/components/alerts";
import { Trash2, Pencil, List, Bookmark, Copy, Clock, Calendar, CheckCircle2, PauseCircle, ClipboardList, User, Building, BedDouble, Users, Download } from "lucide-react";
import handleSidebar from "lib/handleSidebar";
import { userController } from 'lib/user';
import axios from 'axios';
import BeatLoader from "react-spinners/BeatLoader";
import FormGenerate from "views/global/FormGenerate";
import handleConfirmation from 'lib/handleConfirmation';
import DOMPurify from 'dompurify';
import { departmentLabels, priorityLabels, taskStatusLabels, toOptions, labelFor } from 'lib/labels';


function TaskTab(props) {

    const { id, title } = props;

    const { setAlert, clearAlert, showAlert } = QuickAlert();
    const {saveRecord, getSingleRecord, userDetail, deleteRecord} = userController();
    //get the current id from the url
    const { getUser } = userDetail();
    const advanceGroup = ["admin","office","maintenance"].includes(getUser.role);

    const [input, setInput] = useState(id ? {property_id: id} : null);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const [status, setStatus] = useState({
        sidebarForm: false,
        loading: false,
        formLoading: false,
        saveNewList: false,
        editListEnabled: false,
        viewListEnabled: false,
        taskTitle: "",
        selectedImage: null,
        newComment: null,
    });
    const trigerSaveList = status.saveNewList ? false : true;
    const uploadID = id ? id+getUser.id : Math.floor(10000 + Math.random() * 90000)+getUser.id;
    const fieldNames          = []
    if(!id){
        fieldNames.push({label:"Seleziona proprietà", name:"property_id", type:"dynamic-select", dynamic_label:"identifier", required: true, src:"/user/dynamic/list/properties", placeholder:"nome proprietà", permissions: ["maintenance"]});
    }
    fieldNames.push(...[
        {label: "Stanza (opzionale)", name:"property_room_id", type:"dynamic-select", depends_on:"property_id", dynamic_label:"description", src:"/user/dynamic/list/property-rooms", placeholder:"stanza", required: false, permissions: ["maintenance"], permissionType :"new"},
        {label: "ID Prenotazione", name:"reservation_id", type:"text", required: false, permissions: ["maintenance"], permissionType :"new"},
        {label: "Titolo", name:"title", type:"text", required: true, permissions: ["maintenance"], permissionType :"new"},
        {label: "Allegato", name:"attachment", type:"file", required: false, uploadURL:"/user/attachment/upload", deleteURL:"/user/attachment/delete",uploadKey:"task_id", uploadID:uploadID, permissions: ["operation","maintenance"], permissionType :"new"},
        {label:"Descrizione", name:"description", type:"editor", required: false, permissions: ["maintenance"], permissionType :"new"},
        {label: "Indirizzo Ospite", name:"guest_address", type:"text", required: false, permissions: ["maintenance","operation"], permissionType :"new"},
        {label: "Reparto", name:"department", type:"select", required: false, options: toOptions(departmentLabels)},
        {label:"Assegna a", name:"assignee_id", type:"dynamic-select", required: false, src:"/user/dynamic/list/users", placeholder:"nome membro"},
        {label:"Categoria", name:"categories_id", type:"dynamic-select", required: false, src:"/user/dynamic/list/categories", placeholder:"nome categoria", permissions: ["maintenance"], permissionType :"new"},
        {label: false, name:"categories_id_new", type:"text", required: false, placeholder:"Oppure crea una nuova categoria"},
        {label:"Tag", name:"tags", type:"dynamic-select", required: false, src:"/user/dynamic/list/tags", placeholder:"nome tag", multiple:true, permissions: ["maintenance"], permissionType :"new"},
        {label: false, name:"tags_new", type:"text", required: false, placeholder:"aggiungi nuovi tag separati da virgola"},
        {label: "Priorità", name:"priority", type:"select", required: false, options: toOptions(priorityLabels), permissions: ["operation", "maintenance"]},
        {label: "Scadenza", name:"due_date", type:"datetime-local", required: false, permissions: ["operation", "maintenance"]},
        {label: "Stato", name:"status", type:"select", required: false, options: toOptions(taskStatusLabels), permissions: ["operation", "cleaner", "maintenance"]},
    ]);

    const openTaskDetail = (item) => {
        setStatus(prevStatus => ({
            ...prevStatus,
            sidebarForm: true,
            viewListEnabled: true,
            taskTitle: item.title,
            formLoading: true
        }));
        handleSidebar();
        getSingleRecord("/user/task/get/" + item.id).then(response => {
            setInput((prev) => ({ ...prev, ...response.data.item }));
            setStatus(prevStatus => ({ ...prevStatus, formLoading: false }));
        }).catch(function(error) {
            setAlert("error", error.response.data.errors);
            setStatus(prevStatus => ({ ...prevStatus, formLoading: false }));
        });
    };

    const checkboxMenu = [
        {
            icon: <Trash2 />,
            name: "Elimina",
            color: "red",
            handle : (checked) => handleConfirmation(checked, "delete", {one: "l'attività selezionata", many: "le attività selezionate"}, "Questa azione non può essere annullata.", "/user/task/delete",(response) => {
                clearAlert();
                setStatus(prevStatus => ({
                    ...prevStatus,
                    saveNewList: trigerSaveList,
                }));
                setAlert(response.data.status, response.data.message);
            },
            (error) => {
                setAlert("error",error.response.data.errors);
            }),
        }
    ];
    const tableMenuItems = [
        {
            icon: <Pencil />,
            title: "Modifica Attività",
            handle : (row) => {
                setStatus(prevStatus => ({
                    ...prevStatus,
                    sidebarForm: true,
                    editListEnabled: true,
                    viewListEnabled: false,
                    formLoading: true
                }));
                handleSidebar();
                getSingleRecord("/user/task/get/"+row.id).then(response => {
                    return response;
                }).then(response => {
                    setInput((prev) => ({
                        ...prev,
                        ...response.data.item,
                    }));

                    setStatus(prevStatus => ({
                        ...prevStatus,
                        formLoading: false
                    }));
                }).catch(function(error) {
                    setAlert("error",error.response.data.errors);
                    setStatus(prevStatus => ({
                        ...prevStatus,
                        formLoading: false
                    }));
                });
            },
        },
    ];
    const buttons = advanceGroup ? [
        {
            title: "Crea Attività",
            variant: "outline",
            colorScheme: "brand",
            icon: <List />,
            handle: () => {
                setStatus(prevStatus => ({
                    ...prevStatus,
                    sidebarForm: true,
                    editListEnabled: false,
                    viewListEnabled: false,
                }));
                setInput(id ? {property_id: id} : null);
                handleSidebar();
            }
        },
    ] : false;

    const [downloadingPdf, setDownloadingPdf] = useState(null);

    const downloadAssigneePdf = (assigneeId, assigneeName, filters) => {
        setDownloadingPdf(assigneeId || 'unassigned');
        const token = JSON.parse(localStorage.getItem("token"));
        const params = new URLSearchParams({
            assignee_id: assigneeId || '',
            date_from: filters?.date_from || new Date().toLocaleDateString('en-CA'),
            date_to: filters?.date_to || new Date().toLocaleDateString('en-CA'),
            calander_filter: filters?.calander_filter || 'due_date',
            ...(id ? { property_id: id } : {}),
        });
        axios.get(process.env.REACT_APP_API + "/user/task/download-pdf?" + params.toString(), {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob",
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            const slug = (assigneeName || 'tasks').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
            const dateStr = filters?.date_from || new Date().toLocaleDateString('en-CA');
            const filename = slug + '-' + dateStr + '.pdf';
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch(function(error) {
            setAlert("error", error.response?.data?.errors || { download: ["Download del PDF non riuscito"] });
        }).finally(() => {
            setDownloadingPdf(null);
        });
    };

    const hideList = () => {
        setStatus(prevStatus => ({
            ...prevStatus,
            sidebarForm: false,
            editListEnabled: false,
            viewListEnabled: false,
            taskTitle: "",
        }));
        setInput(id ? {property_id: id} : null);
        handleSidebar(false);
        clearAlert();
    }

    const saveListHandle = () => {
        setStatus(prevStatus => ({
            ...prevStatus,
            loading: true,
        }));
        saveRecord('/user/task/create',input).then(response => {
            return response;
        }).then(response => {
            setStatus(prevStatus => ({
                ...prevStatus,
                loading: false,
                saveNewList: trigerSaveList,
            }));
            hideList();
        }).catch(function(error) {
            setStatus(prevStatus => ({
                ...prevStatus,
                loading: false,
            }));
            setAlert("error",error.response.data.errors);
            SidebarScroll();
        });
    }

    return (
        <>
        <Box>
            {status.sidebarForm===false ? showAlert() : null }
            <BoxDataTable
                title={title}
                buttons={buttons}
                src="/user/task/list"
                additionalOptions={id ? { property_id: id } : null}
                search={true}
                checkbox={id && advanceGroup ? true : false}
                checkboxMenu={checkboxMenu}
                tableMenu={tableMenuItems}
                trigger={status.saveNewList}
                design="dragable"
                dragableType="Task"
                defaultPerPage={50}
                defaultCalander="due_date"
                defaultFilters={{
                    calander_filter: 'due_date',
                    date_from: new Date().toLocaleDateString('en-CA'),
                    date_to:   new Date().toLocaleDateString('en-CA'),
                    organize_by: 'assignee',
                }}
                rowHeading={(item, index, prevItem, filters) => {
                    if (!item.assignee_display) return null;
                    if (item.assignee_display === prevItem?.assignee_display) return null;
                    return (
                        <Flex
                            align="center"
                            gap="10px"
                            px="4px"
                            pt={index > 0 ? "16px" : "4px"}
                            pb="20px"
                        >
                            <Icon as={Users} color="brand.500" boxSize="22px" />
                            <Text fontWeight="700" fontSize="20px" color="gray.600">
                                {item.assignee_display}
                            </Text>
                            {downloadingPdf === (item.assignee_id || 'unassigned') ? (
                                <Box ml="auto"><BeatLoader size={8} color="#422CFA" /></Box>
                            ) : (
                                <Icon
                                    as={Download}
                                    boxSize="22px"
                                    color="gray.600"
                                    cursor="pointer"
                                    ml="auto"
                                    _hover={{ color: "brand.500" }}
                                    onClick={() => downloadAssigneePdf(item.assignee_id, item.assignee_display, filters)}
                                />
                            )}
                        </Flex>
                    );
                }}
                tableContent={(item) => (
                    <Box
                        cursor="pointer"
                        onClick={() => openTaskDetail(item)}
                    >
                        <Text className={"task-item-title " + item.priority} mb="10px">{item.title}</Text>
                        <Flex display={{ base: "block", md: "flex" }}>
                            <Text className="muted-text d-flex d-icon-5" me={4}><Calendar /> {item.due_date}</Text>
                            {!item.assignee_display && item.assignee && (
                                <Text className="d-flex d-icon-5 d-icon-fx-18" color="secondaryGray.900" fontSize="14px" mb="10px" me={4}><User /> {item.assignee.name}</Text>
                            )}
                            {item.department && (
                                <Text className="muted-text d-flex d-icon-5 d-icon-fx-18 text-capitalize" me={4}><ClipboardList /> {labelFor(departmentLabels, item.department)}</Text>
                            )}
                            {item.property && (
                                <Text className="muted-text d-flex d-icon-5 d-icon-fx-18" me={4}><Building /> {item.property.identifier}</Text>
                            )}
                            {item.reservation?.property_room ? (
                                <Text className="muted-text d-flex d-icon-5 d-icon-fx-18" me={4}><BedDouble /> {item.reservation.property_room.description}</Text>
                            ) : item.property_room ? (
                                <Text className="muted-text d-flex d-icon-5 d-icon-fx-18" me={4}><BedDouble /> {item.property_room.description}</Text>
                            ) : null}
                            {item.reservation && (
                                <Text className="muted-text d-flex d-icon-5 d-icon-fx-18"><User /> {item.reservation.name}</Text>
                            )}
                        </Flex>
                    </Box>
                )}
            />
            <SimpleSidebar
            status={status.sidebarForm}
            title={status.viewListEnabled ? status.taskTitle : (status.editListEnabled ? "Modifica Attività" : "Crea Nuova Attività")}
            save={{onClick:saveListHandle,isLoading:status.loading,text:status.editListEnabled ? "Aggiorna Attività" : "Crea Attività"}}
            cancel={{onClick:hideList, text:"Annulla"}}
            loading={status.formLoading}
            viewOnly={status.viewListEnabled}
            >
                {status.sidebarForm===false ?  null : showAlert() }
                {status.sidebarForm===true && !status.viewListEnabled &&
                    <FormGenerate fields={fieldNames} setFields={setInput} defaultValue={input ? input : []}/>
                }
                {status.sidebarForm===true && status.viewListEnabled && input &&
                    <>
                    <Box
                        p={4}
                        borderRadius="md"
                        mb={4}
                        border={"1px solid"}
                        borderColor={"gray.200"}
                    >
                        <Box
                        mb={4}
                        className='task-header-meta'
                        display={{base:"block", md:"flex"}}
                        justifyContent={{base:"center", md:"space-between"}}
                        alignItems={{base:"center", md:"center"}}
                        >
                            {input.assigned_at &&
                            <Text className='task-header-created-date task-header-item'>
                                <Clock/>
                                {input.assigned_at}
                            </Text>
                            }
                            {input.due_date &&
                            <Text className="task-header-due-date task-header-item">
                                <Calendar/>
                                {input.due_date}
                            </Text>
                            }
                            {input.status &&
                            <Text className={input.status+ ' task-header-status task-header-item'}>
                                {input.status==="completed" ? <CheckCircle2/> : <PauseCircle/>}
                                {input.status==="completed" ? input.completed_at : labelFor(taskStatusLabels, input.status)}
                            </Text>
                            }
                        </Box>
                        <Box
                        className='task-header-meta'
                        display={{base:"block", md:"flex"}}
                        alignItems={{base:"center", md:"center"}}
                        gap={4}
                        >
                            {input.property &&
                            <Text className='task-header-property task-header-item'>
                                <Building/>
                                {input.property.identifier}
                            </Text>
                            }
                            {input.reservation?.property_room ? (
                                <Text className="task-header-property task-header-item">
                                    <BedDouble />
                                    {input.reservation.property_room.description}
                                </Text>
                            ) : input.property_room ? (
                                <Text className="task-header-property task-header-item">
                                    <BedDouble />
                                    {input.property_room.description}
                                </Text>
                            ) : null}
                        </Box>
                    </Box>
                    {input.reservation && (
                        <Box
                        mb={4}
                        className='task-header-meta wr-info-card'
                        display={{base:"block", md:"flex"}}
                        alignItems={{base:"center", md:"center"}}
                        borderWidth="1px"
                        borderColor="gray.200"
                        borderRadius={5}
                        padding={4}
                        >   
                            <>
                            <Text className='wr-info-card-header'>Prenotazione</Text>
                            <Text className="task-header-assignee  task-header-item" me={5}>
                                Nome: <span>{input.reservation.name}</span>
                            </Text>
                            <Text className="task-header-assignee  task-header-item" me={5}>
                                ID: <span>{input.reservation.id ? input.reservation.id : "-"}</span>
                            </Text>
                            </>  
                        </Box>
                    )}
                    <Box
                    mb={4}
                    className='task-header-meta wr-info-card'
                    display={{base:"block", md:"flex"}}
                    alignItems={{base:"center", md:"center"}}
                    borderWidth="1px"
                    borderColor="gray.200"
                    borderRadius={5}
                    padding={4}
                    >
                        <Text className='wr-info-card-header'>Gestione</Text>
                        <Text className="task-header-assignee  task-header-item" me={5}>
                            Creata da: <span>{input.user ? input.user.name : "Admin"}</span>
                        </Text>
                        {input.assignee && (
                            <Text className="task-header-assignee  task-header-item">
                                Assegnata a: <span> {input.assignee.name}</span>
                            </Text>
                        )}
                        {input.department && (
                            <Text className="task-header-assignee  task-header-item">
                                Reparto: <span> {labelFor(departmentLabels, input.department)}</span>
                            </Text>
                        )}
                    </Box>
                    {input.guest_address && (
                        <Box
                        mb={4}
                        className='task-header-meta wr-info-card'
                        display={{base:"block", md:"flex"}}
                        alignItems={{base:"center", md:"center"}}
                        borderWidth="1px"
                        borderColor="gray.200"
                        borderRadius={5}
                        padding={4}
                        >   
                            <Text className='wr-info-card-header'>Indirizzo Ospite</Text>
                            <Text className="task-header-assignee  task-header-item" me={5}>{input.guest_address}</Text>
                        </Box>
                    )}
                    <Text
                    mb={4}
                    >
                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(input.description) }} />
                    </Text>
                    <Box
                    className='task-footer-meta'
                    >
                        {input.categories &&
                        <Text
                        className='task-category-item'
                        >
                            <Copy/>
                            {input.categories.name}
                        </Text>
                        }
                        {input.tags && input.tags.map((tag, index) => (
                            <Text key={index} className='task-tags-item'>
                                <Bookmark/> {tag}
                            </Text>
                        ))}
                    </Box>
                    <Box
                    display={input.attachments && input.attachments.length > 0 ? "block" : "none"}
                    mb={4}
                    >
                        {input.attachments && input.attachments.length > 0 && input.attachments.map((attachment, index) => (
                            <Box
                            key={index}
                            className='attachment-preview'
                            >
                                <Box
                                display="flex"
                                justifyContent='center'
                                alignItems='center'
                                flexDirection='column'
                                width='100%'
                                height="100%"
                                onClick={()=>{
                                    setStatus(prevStatus => ({
                                        ...prevStatus,
                                        selectedImage: attachment.path,
                                    }));
                                    onOpen();
                                }}
                                cursor={"pointer"}
                                >
                                <img src={process.env.REACT_APP_URL+"/"+attachment.path} alt={attachment.name} />
                                </Box>
                            </Box>
                        ))}
                    </Box>
                    <Modal
                    isCentered
                    onClose={onClose}
                    isOpen={isOpen}
                    motionPreset="slideInBottom"
                    >
                        <ModalOverlay />
                        <ModalContent>
                            <ModalCloseButton />
                            <ModalBody>
                                {status.selectedImage &&
                                <img src={process.env.REACT_APP_URL+"/"+status.selectedImage} alt="attachment" />
                                }
                            </ModalBody>
                        </ModalContent>
                    </Modal>
                    
                    <Box mb={8}>
                        <Textarea
                        placeholder='Scrivi qui il tuo commento'
                        mb={2}
                        value={status.newComment ? status.newComment : ""}
                        onChange={(e) => setStatus(prevStatus => ({
                            ...prevStatus,
                            newComment: e.target.value
                        }))}
                        >
                        </Textarea>
                        <Box textAlign="right">
                            <Button
                            colorScheme="brand"
                            size="sm"
                            onClick={() => {
                                saveRecord('/user/comment/add', {comment: status.newComment, task_id: input.id, property_id: input.property_id}).then(response => {
                                    return response;
                                }).then(response => {
                                    setInput((prev) => ({
                                        ...prev,
                                        comments: [response.data.comment, ...prev.comments], // append new comment to the list
                                    }));
                                    setStatus(prevStatus => ({
                                        ...prevStatus,
                                        newComment: null,
                                    }));
                                }).catch(function(error) {
                                    setAlert("error",error.response.data.errors);
                                });
                            }}
                            >
                                Aggiungi Commento
                            </Button>
                        </Box>
                    </Box>
                    <Box
                    display={input.comments && input.comments.length > 0 ? "block" : "none"}
                    mb={4}
                    className='comments-container'
                    >
                        {input.comments && input.comments.length > 0 && input.comments.map((comment, index) => (
                        <Box
                        className='comments-item'
                        key={index}
                        mb={8}
                        >
                            <Box
                            display={{base:"block", md:"flex"}}
                            >
                                <Box>
                                    <Box
                                    className={'circle-string item-' + comment.user.name.charAt(0).toLowerCase()}
                                    >
                                    {comment.user.name.charAt(0) + comment.user.name.charAt(1)}
                                    </Box>
                                </Box>
                                <Box>
                                    <Text
                                    className='comment-header'
                                    >
                                    {comment.user.name} <span>{comment.created_at}</span>
                                    </Text>
                                    {comment.comment}
                                    {comment.user.id === getUser.id &&
                                        <span
                                        className='comment-footer'
                                        onClick={() => {
                                            deleteRecord('/user/comment/delete', {id: comment.id}).then(response => {
                                                setInput((prev) => ({
                                                    ...prev,
                                                    comments: prev.comments.filter(item => item.id !== comment.id), // remove the comment from the list
                                                }));
                                            }
                                            ).catch(function(error) {
                                                setAlert("error",error.response.data.errors);
                                            });
                                        }}
                                        >
                                        Elimina
                                        </span>
                                    }
                                </Box>
                            </Box>
                        </Box>
                        ))}
                    </Box>
                    </>
                }
            </SimpleSidebar>
        </Box>
        </>

    );
}
export default TaskTab;
